import React,{useEffect, useState} from "react";

import { Link, useNavigate } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Image
import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';
import { WHATSAPP_HREF } from './SupportoNelMenu';
import { ReactComponent as LogoSportID } from '../../../images/logo-nero-sportid.svg';
import SidBreadcrumb from '../SidBreadcrumb';
import { useManagerSubscription } from '../../../context/ManagerSubscriptionContext';

// Stesso numero e messaggio di default del vecchio pulsante flottante
// (WhatsAppWidget, rimosso): ora il link vive qui, accanto al supporto ticket.

// Riga sottile sopra tutta la pagina (vedi jsx/index.js), non piu' nella testata
export const BarraProvaGratuita = () => {
  const { subscription } = useManagerSubscription();
  const navigate = useNavigate();
  const isTrial = !!subscription && subscription.active && subscription.status === 'active' && subscription.priceEur === 0;

  // La riga e` fissa in alto: la classe sul body sposta sotto di lei testata, menu e contenuto (vedi .sid-con-barra-prova)
  useEffect(() => {
    if (!isTrial) return undefined;
    document.body.classList.add('sid-con-barra-prova');
    return () => document.body.classList.remove('sid-con-barra-prova');
  }, [isTrial]);

  if (!isTrial) return null;

  const getDaysRemaining = (endDateStr) => {
    if (!endDateStr) return null;
    const end = new Date(endDateStr + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.floor((end.getTime() - today.getTime()) / 86400000);
  };
  const formatDateIt = (dateStr) => {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  };
  const days = getDaysRemaining(subscription.endDate);
  const text = days > 0
    ? `Sei in prova gratuita. Rimangono ${days} giorni (fino al ${formatDateIt(subscription.endDate)})`
    : `La prova gratuita scade oggi`;

  return (
    <div
      className="sid-barra-prova"
      role="button"
      tabIndex={0}
      onClick={() => navigate('/abbonamento')}
      onKeyDown={(e) => e.key === 'Enter' && navigate('/abbonamento')}
      title="Attiva l'abbonamento"
    >
      {text}
    </div>
  );
};

const Header = ({ onNote }) => {

  const [displayName, setDisplayName] = useState("");
  const [displayEmail, setDisplayEmail] = useState("");

  useEffect(() => {

    const tokenDetailsString = sessionStorage.getItem('userDetails');
    const tokenDetails = JSON.parse(tokenDetailsString);
    setDisplayEmail(tokenDetails.email);
    setDisplayName(tokenDetails.displayName);

  }, []);

  // const [searchBut, setSearchBut] = useState(false);	
  
  return ( 
    <div className="header border-bottom">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              {/* Su smartphone il logo SportID sta sempre in testata (il resto del menu è dietro il tasto ☰) */}
              <Link to={`/${sessionStorage.getItem('userType') || 'struttura'}/dashboard`} className="sid-header-logo" aria-label="SportID"><LogoSportID /></Link>
              <SidBreadcrumb />
            </div>
            <ul className="navbar-nav header-right">
				<li className="nav-item d-flex align-items-center">
					{/*
          <div className="input-group search-area">
            <input type="text" 
							className={`form-control ${searchBut ? "active" : ""}`}
							placeholder="Cerca nell'app..." 
						/>
						<span className="input-group-text" onClick={() => setSearchBut(!searchBut)}>
							<Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
						</span>
					</div>
          */}

          <span style={{ fontSize: '13px', color: 'var(--sid-text)', marginRight: '8px' }}>Supporto clienti</span>
          <span className="input-group-text">
            <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer">Whatsapp</a>
          </span>
          <span className="input-group-text">
            {/* Ticket: pagina del Manager con il widget di LUME, nome ed email gia' compilati */}
            <Link to={window.location.pathname.startsWith('/superadmin') ? '/superadmin/ticket' : '/struttura/ticket'}>Ticket</Link>
          </span>
				</li> 
				
				<Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown "
              >
                <Dropdown.Toggle className="nav-link i-false c-pointer" variant="" as="a"
					data-toggle="dropdown" aria-expanded="false"
                >
					<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M23.3333 19.8333H23.1187C23.2568 19.4597 23.3295 19.065 23.3333 18.6666V12.8333C23.3294 10.7663 22.6402 8.75902 21.3735 7.12565C20.1068 5.49228 18.3343 4.32508 16.3333 3.80679V3.49996C16.3333 2.88112 16.0875 2.28763 15.6499 1.85004C15.2123 1.41246 14.6188 1.16663 14 1.16663C13.3812 1.16663 12.7877 1.41246 12.3501 1.85004C11.9125 2.28763 11.6667 2.88112 11.6667 3.49996V3.80679C9.66574 4.32508 7.89317 5.49228 6.6265 7.12565C5.35983 8.75902 4.67058 10.7663 4.66667 12.8333V18.6666C4.67053 19.065 4.74316 19.4597 4.88133 19.8333H4.66667C4.35725 19.8333 4.0605 19.9562 3.84171 20.175C3.62292 20.3938 3.5 20.6905 3.5 21C3.5 21.3094 3.62292 21.6061 3.84171 21.8249C4.0605 22.0437 4.35725 22.1666 4.66667 22.1666H23.3333C23.6428 22.1666 23.9395 22.0437 24.1583 21.8249C24.3771 21.6061 24.5 21.3094 24.5 21C24.5 20.6905 24.3771 20.3938 24.1583 20.175C23.9395 19.9562 23.6428 19.8333 23.3333 19.8333Z" fill="#717579"/>
						<path d="M9.98192 24.5C10.3863 25.2088 10.971 25.7981 11.6766 26.2079C12.3823 26.6178 13.1839 26.8337 13.9999 26.8337C14.816 26.8337 15.6175 26.6178 16.3232 26.2079C17.0288 25.7981 17.6135 25.2088 18.0179 24.5H9.98192Z" fill="#717579"/>
					</svg>
					<span className="badge light text-white bg-blue rounded-circle">0</span>
                </Dropdown.Toggle>
				        <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end">
                  <PerfectScrollbar className="widget-media dlab-scroll p-3 height80">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-panel">
                        <div className="media-body">
                          <h6 className="mb-1" style={{ textAlign: 'center' }}>Nessuna notifica presente</h6>
                        </div>
                        </div>
                      </li>
                    </ul>
                    {/*
                    <ul className="timeline">
                      <li>
                        <div className="timeline-panel">
                        <div className="media me-2">
                          <img alt="images" width={50} src={avatar} />
                        </div>
                        <div className="media-body">
                          <h6 className="mb-1">Dr sultads Send you Photo</h6>
                          <small className="d-block">
                            29 July 2023 - 02:26 PM
                          </small>
                        </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-info">KG</div>
                          <div className="media-body">
                            <h6 className="mb-1">
                              Resport created successfully
                            </h6>
                            <small className="d-block">
                              29 July 2023 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-success">
                            <i className="fa fa-home" />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Reminder : Treatment Time!</h6>
                            <small className="d-block">
                              29 July 2023 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2">
                            <img alt="" width={50} src={avatar} />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Dr sultads Send you Photo</h6>
                            <small className="d-block">
                              29 July 2023 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-danger">KG</div>
                          <div className="media-body">
                            <h6 className="mb-1">
                              Resport created successfully
                            </h6>
                            <small className="d-block">
                              29 July 2023 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-primary">
                            <i className="fa fa-home" />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Reminder : Treatment Time!</h6>
                            <small className="d-block">
                              29 July 2023 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                      <div
                        className="ps__thumb-x"
                        tabIndex={0}
                        style={{ left: 0, width: 0 }}
                      />
                    </div>
                    <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
                      <div
                        className="ps__thumb-y"
                        tabIndex={0}
                        style={{ top: 0, height: 0 }}
                      />
                    </div>
                    */}
                  </PerfectScrollbar>
                  <Link className="all-notification" to="#">
                    Visualizza tutto <i className="ti-arrow-right" />
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
        {/*
				<Dropdown
					as="li"
					className="nav-item dropdown notification_dropdown "
				  >
					<Dropdown.Toggle
					  variant=""
					  as="a"
					  className="nav-link bell bell-link i-false c-pointer"
					  onClick={() => onNote()}
					>
						<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M27.076 6.24662C26.962 5.48439 26.5787 4.78822 25.9955 4.28434C25.4123 3.78045 24.6679 3.50219 23.8971 3.5H4.10289C3.33217 3.50219 2.58775 3.78045 2.00456 4.28434C1.42137 4.78822 1.03803 5.48439 0.924011 6.24662L14 14.7079L27.076 6.24662Z" fill="#717579"/>
							<path d="M14.4751 16.485C14.3336 16.5765 14.1686 16.6252 14 16.6252C13.8314 16.6252 13.6664 16.5765 13.5249 16.485L0.875 8.30025V21.2721C0.875926 22.1279 1.2163 22.9484 1.82145 23.5536C2.42659 24.1587 3.24707 24.4991 4.10288 24.5H23.8971C24.7529 24.4991 25.5734 24.1587 26.1786 23.5536C26.7837 22.9484 27.1241 22.1279 27.125 21.2721V8.29938L14.4751 16.485Z" fill="#717579"/>
						</svg>
						<span className="badge light text-white bg-secondary rounded-circle">0</span>
					</Dropdown.Toggle>
				</Dropdown>	
        */}
        {/*
			  <Dropdown
                as="li"
                className="nav-item  notification_dropdown "
              >
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link  ai-icon i-false c-pointer"
                  role="button"
                 
                >
					<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M22.1666 5.83331H20.9999V3.49998C20.9999 3.19056 20.877 2.89381 20.6582 2.67502C20.4394 2.45623 20.1427 2.33331 19.8333 2.33331C19.5238 2.33331 19.2271 2.45623 19.0083 2.67502C18.7895 2.89381 18.6666 3.19056 18.6666 3.49998V5.83331H9.33325V3.49998C9.33325 3.19056 9.21034 2.89381 8.99154 2.67502C8.77275 2.45623 8.47601 2.33331 8.16659 2.33331C7.85717 2.33331 7.56042 2.45623 7.34163 2.67502C7.12284 2.89381 6.99992 3.19056 6.99992 3.49998V5.83331H5.83325C4.90499 5.83331 4.01476 6.20236 3.35838 6.85844C2.702 7.51482 2.33325 8.40506 2.33325 9.33331V10.5H25.6666V9.33331C25.6666 8.40506 25.2978 7.51482 24.6415 6.85844C23.9851 6.20236 23.0948 5.83331 22.1666 5.83331Z" fill="#717579"/>
						<path d="M2.33325 22.1666C2.33325 23.0949 2.702 23.9851 3.35838 24.6415C4.01476 25.2979 4.90499 25.6666 5.83325 25.6666H22.1666C23.0948 25.6666 23.9851 25.2979 24.6415 24.6415C25.2978 23.9851 25.6666 23.0949 25.6666 22.1666V12.8333H2.33325V22.1666Z" fill="#717579"/>
					</svg>
					<span className="badge light text-white bg-primary rounded-circle">0</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-4 dropdown-menu dropdown-menu-end">
                  <PerfectScrollbar className="widget-timeline dlab-scroll style-1 ps p-3 height370">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-badge primary" />
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>10 minutes ago</span>
                          <h6 className="mb-0">
                            Youtube, a video-sharing website, goes live{" "}
                            <strong className="text-primary">$500</strong>.
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge info"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>20 minutes ago</span>
                          <h6 className="mb-0">
                            New order placed{" "}
                            <strong className="text-info">#XF-2356.</strong>
                          </h6>
                          <p className="mb-0">
                            Quisque a consequat ante Sit amet magna at
                            volutapt...
                          </p>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge danger"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>30 minutes ago</span>
                          <h6 className="mb-0">
                            john just buy your product{" "}
                            <strong className="text-warning">Sell $250</strong>
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge success"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>15 minutes ago</span>
                          <h6 className="mb-0">
                            StumbleUpon is acquired by eBay.{" "}
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge warning"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>20 minutes ago</span>
                          <h6 className="mb-0">
                            Mashable, a news website and blog, goes live.
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge dark"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>20 minutes ago</span>
                          <h6 className="mb-0">
                            Mashable, a news website and blog, goes live.
                          </h6>
                        </Link>
                      </li>
                    </ul>
                    <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                      <div
                        className="ps__thumb-x"
                        tabIndex={0}
                        style={{ left: 0, width: 0 }}
                      />
                    </div>
                    <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
                      <div
                        className="ps__thumb-y"
                        tabIndex={0}
                        style={{ top: 0, height: 0 }}
                      />
                    </div>
                  </PerfectScrollbar>
                </Dropdown.Menu>
              </Dropdown>
              */}
				<Dropdown as="li" className="nav-item dropdown header-profile">
					<Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer"
						role="button" data-toggle="dropdown"
					>
						{/*<img src={loginbg} width={20} alt="" />*/}
						<span className="sid-header-avatar" role="img" aria-label="Account utente" />
						<div className="header-info">
							<span className="fs-18 font-w500 mb-2">
              {/*userType === 'struttura' && <>Struttura</>*/}
              {/*userType === 'maestro' && <>Maestro</>*/}
              {/*userType === 'superadmin' && <>Super Admin</>*/}
              {displayName}
              </span>
							<small className="fs-12 font-w400">{displayEmail}</small>
						</div>
					</Dropdown.Toggle>
					<Dropdown.Menu align="right" className="mt-3  mt-lg-0 dropdown-menu dropdown-menu-end">
					  {/*
            <Link to="/app-profile" className="dropdown-item ai-icon">
						<svg
						  id="icon-user1" xmlns="http://www.w3.org/2000/svg" className="text-primary me-1"
						  width={18} height={18} viewBox="0 0 24 24" fill="none"
						  stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
						>
						  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
						  <circle cx={12} cy={7} r={4} />
						</svg>
						<span className="ms-2">Profile </span>
					  </Link>
					  <Link to="/email-inbox" className="dropdown-item ai-icon">
						<svg
						  id="icon-inbox" xmlns="http://www.w3.org/2000/svg" className="text-success me-1" width={18}
						  height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
						  strokeLinecap="round" strokeLinejoin="round"
						>
						  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
						  <polyline points="22,6 12,13 2,6" />
						</svg>
						<span className="ms-2">Inbox </span>
					  </Link>
            */}
					  <Link to={`/${sessionStorage.getItem('userType') || 'struttura'}/account`} className="dropdown-item ai-icon">
						<svg xmlns="http://www.w3.org/2000/svg" className="me-1" width={18} height={18} viewBox="0 0 24 24" fill="none"
						  stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
						  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
						  <circle cx={12} cy={7} r={4} />
						</svg>
						<span className="ms-2">Account</span>
					  </Link>
					  <LogoutPage />
					</Dropdown.Menu>
				</Dropdown> 
				
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
